//hemos instalado jwt-decode
import { jwtDecode } from "jwt-decode";

export const hasexpiredToken = (token) => {
  if (!token || token.split(".").length !== 3) {
    console.error("Token is invalid:");
    return true; // O maneja este caso según convenga
  }
  const { exp } = jwtDecode(token); //obtenemos la fecha de expiracion del token y la guardamos en exp
  const currentData = new Date().getTime() / 1000; //obtenemos la fecha actual y la guardamos en currentData
  if (exp <= currentData) {
    //si la fecha de expiracion es menor o igual a la fecha actual
    return true;
  }
  return false;
};
